"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genCellClasses = exports.createColData = exports.editorRender = exports.cellRender = void 0;
var React = __importStar(require("react"));
var Cell_1 = __importDefault(require("../components/DataTable/Cell/Cell"));
function cellRender(rowData, column, tableProps) {
    var data = createColData(column);
    var hasContent = data.value === 0 || data.value;
    var onCellClick = tableProps.onCellClick, onCellEnter = tableProps.onCellEnter, onCellLeave = tableProps.onCellLeave;
    var content = rowData[column.field];
    if (!hasContent && data.placeholder) {
        content = React.createElement("span", { className: "cell-placeholder" }, data.placeholder);
    }
    if (column.renderer) {
        content = column.renderer(data);
    }
    return (React.createElement(Cell_1.default, { onCellClick: onCellClick, onCellEnter: onCellEnter, onCellLeave: onCellLeave, data: data, content: content }));
}
exports.cellRender = cellRender;
function editorRender(columnProps, tableProps) {
    var onEdit = tableProps.onEdit;
    var editable = columnProps.editable, customEditRenderer = columnProps.customEditRenderer, editFieldType = columnProps.editFieldType, field = columnProps.field;
    var editor = undefined;
    if (editable) {
        if (customEditRenderer) {
            editor = function (props) { return customEditRenderer(createColData(props)); };
        }
        else {
            editor = function (props) { return (React.createElement("input", { type: editFieldType, className: "cell-row-input", value: props.rowData[field], onChange: onEdit ?
                    function (event) { return onEdit(event.target.value, createColData(props)); } :
                    undefined })); };
        }
    }
    return editor;
}
exports.editorRender = editorRender;
function createColData(column) {
    return {
        rowData: column.rowData,
        rowIndex: column.rowIndex,
        selected: column.selected,
        placeholder: column.placeholder,
        sortable: column.sortable,
        value: column.rowData[column.field],
        field: column.field,
        name: column.header,
        editable: column.editable
    };
}
exports.createColData = createColData;
function genCellClasses(columnProps) {
    var classes = '';
    if (columnProps.className) {
        classes += columnProps.className;
    }
    if (columnProps.align) {
        classes += " align-" + columnProps.align;
    }
    if (columnProps.rowHeader) {
        classes += ' rowHeader';
    }
    return classes;
}
exports.genCellClasses = genCellClasses;
//# sourceMappingURL=cellContentHelpers.js.map